import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
export default /*#__PURE__*/_defineComponent({
  __name: 'CBean',
  props: {
    icon: null
  },
  setup: function setup(__props) {
    return {
      __sfc: true,
      SIcon: SIcon
    };
  }
});